import { ArrowLeft16 } from '@elfsight/icons';
import { createReadableClass } from '@elfsight/widget-utils';
import { useCheckoutI18n, useCheckoutNavigation } from '../providers';
import { TextButton } from './text-button';

export function OrderSummaryButton({ color }: { color: string }) {
  const { t } = useCheckoutI18n();
  const { openSummary } = useCheckoutNavigation();

  return (
    <TextButton
      color={color}
      onClick={openSummary}
      className={createReadableClass({
        component: 'order-summary-button'
      })}
    >
      {t('Order Summary')}
    </TextButton>
  );
}

export function BackButton({
  color,
  onClick
}: {
  color: string;
  onClick: () => void;
}) {
  const { t } = useCheckoutI18n();

  return (
    <TextButton
      color={color}
      onClick={onClick}
      className={createReadableClass({
        component: 'back-button'
      })}
      leftIcon={ArrowLeft16}
    >
      {t('Back')}
    </TextButton>
  );
}
